import React, { useEffect, useState } from "react";
import { AiOutlineHeart, AiFillHeart } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { AddFavorite, removeProductFromFavorite } from "../../redux/Slices/FavoriteSlice";
import notify from "../UseNotification";


const UseAddFavorite = (item, favList) => {
    const dispatch = useDispatch()
    let Favorite = favList.some(favItem => favItem === item._id)
    const [FavImage, setFavImage] = useState(<AiOutlineHeart />)
    const [addLoading, setAddLoading] = useState(true)
    const { addFavorite, removeFavorite } = useSelector(state => state.FavoriteReducer)
    const [removeLoading, setRemoveLoading] = useState(true)
    const [IsFav, setIsFav] = useState(Favorite)

    // to set IsFav value
    useEffect(() => {
        setIsFav(Favorite)
    }, [favList])

    // to change Favorite icon
    const handleFav = () => {
        if (IsFav === true) {
            HandleRemoveProductFromFavorite()
        } else {
            HandleAddProductToFavorite()
        }
    }

    // to change fav icon based on the Is Fav value
    useEffect(() => {
        if (IsFav === true) {
            setFavImage(<AiFillHeart className="orange-color" />)
        } else {
            setFavImage(<AiOutlineHeart />)
        }
    }, [IsFav])


    // handle add product to favorite 
    const HandleAddProductToFavorite = async () => {
        setIsFav(true)
        setFavImage(<AiFillHeart className="orange-color" />)
        setAddLoading(true)
        await dispatch(AddFavorite({
            productId: item._id
        }))
        setAddLoading(false)
    }


    // handle the add wishlist request response
    useEffect(() => {
        if (addLoading === false) {
            if (addFavorite.status === 200) {
                notify("product added to wishlist", "success")
                window.location.reload(false)
            } else if (addFavorite.response.status === 500) {
                notify("you are not login", "error")
                setFavImage(<AiOutlineHeart />)
            }
        }
    }, [addLoading])


    // handle remove product from favorite 
    const HandleRemoveProductFromFavorite = async () => {
        setIsFav(false)
        setFavImage(<AiOutlineHeart />)
        setRemoveLoading(true)
        await dispatch(removeProductFromFavorite(item._id))
        setRemoveLoading(false)
    }

    // to check the resonse of remove product from wishlist
    useEffect(() => {
        if (removeLoading === false) {
            if (removeFavorite.status === 200) {
                notify("product removed from wishlist", "success")
                window.location.reload(false)
            } else if (addFavorite.response.status === 500) {
                notify("you are not login", "error")
                setFavImage(<AiOutlineHeart />)
            }
        }
    }, [removeLoading])


    return [handleFav, FavImage]

}

export default UseAddFavorite
